import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import AppLayout from "layouts/appLayout/layout";

const PrivateRoute = ({ element, permissions }) => {
  const user = useSelector((state) => state.auth.user);

  // Si pas connecté → redirection login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Vérification des permissions si passées en props
  if (permissions) {
    const required = Array.isArray(permissions) ? permissions : [permissions];

    // Selon ta structure, c’est peut-être user.roleId.permissions
    const userPermissions = user?.roleId?.permissions || [];

    const hasPermission = required.some((p) => userPermissions.includes(p));

    if (!hasPermission) {
      return <Navigate to="/" replace />;
    }
  }

  // Sinon on affiche le layout + page
  return <AppLayout>{element}</AppLayout>;
};

export default PrivateRoute;
